module.exports = require('./lib').default;
module.exports.default = module.exports;
module.exports.NextButton = require('./lib').NextButton;
module.exports.PreviousButton = require('./lib').PreviousButton;
module.exports.PagingDots = require('./lib').PagingDots;



//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/index.js
// module id = 555
// module chunks = 35783957827783